"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Ng2OdometerConfig = (function () {
    function Ng2OdometerConfig() {
        this.animation = 'slide';
        this.format = '(,ddd)';
        this.theme = 'default';
        this.value = 0;
        this.duration = 2000;
        this.auto = true;
    }
    return Ng2OdometerConfig;
}());
exports.Ng2OdometerConfig = Ng2OdometerConfig;
//# sourceMappingURL=odometer.config.js.map